/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/no-unescaped-entities */
import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { BackImage } from 'C4';
import Logo from 'assets/images/logo/logo_vita.png';

export default class VitaView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const fancyOptions = {
      infobar: true,
      thumbs: {
        autoStart: true,
        axis: 'x',
      },
      baseClass: 'customBox',
      buttons: ['close'],
    };
    
    return (
      <div className="contentContainerLeader">
        <BackImage darken />
        <div className="leadersClubView">
          <img src={`/${Logo}`} className="logo vita" alt="logo" />
          <div className="header">
            <h1>Leaders Club Points-Eligible Rates</h1>
            <p>
              We’ve expanded Leaders Club points eligibility on all bookings with VITA commissionable rates at participating VITA
              hotels. Travelers enrolled in Leaders Club and booked with VITA commissionable rates will earn points and continue to enjoy on-property
              VITA benefits, while you keep earning commission.
              <br />
              <br />
              Leaders Club benefits cannot be duplicated or combined, therefore travelers enrolled in Leaders Club and booked with VITA commissionable
              rates at participating VITA hotels will continue to receive on-property VITA benefits during their stays. Travelers enrolled in Leaders
              Club and booked with a consortia rate code will earn points and receive on-property luxury consortia benefits.
            </p>
          </div>

          <div className="imageOnCopy">
            <img src="https://front.travpromobile.com/678/Aerea (1).jpeg" className="splitter" alt="" />
            <div className="copy">
              <h2>OUR COMMITMENT TO YOU </h2>
              <p>
                It is our pledge to invest in even more ways to strengthen our partnership with you so you can continue to offer your clients more. We
                respect all you do to bring your clients excellent travel experiences, and appreciate you sharing our collection of unique properties
                with them.
              </p>
            </div>
          </div>

          <div className="imageOnCopy">
            <img src="https://front.travpromobile.com/678/LDV036_pool_ocean_(edited).jpeg" className="splitter" alt="" />
            <div className="copy right">
              <h2>HAVE QUESTIONS?</h2>
              <p>
                We understand the importance of providing you all the information you need to share these changes with your clients. Here, you will
                find answers to commonly asked questions about the recent enhancements to Leaders Club and how new points-eligible rates affect
                your business.
                <br />
                <br />
                <a href="https://front.travpromobile.com/678/faq_vita.pdf" data-type="iframe" data-fancybox="https://front.travpromobile.com/678/faq_vita.pdf" dataOptions={JSON.stringify(fancyOptions)} data-fancybox-trigger="pdf">
                  View FAQs &gt;
                </a>
                <br />
                <br />
                CAN'T FIND YOUR QUESTION?
                <br />
                Send us an email and we will be happy to assist you
                <br />
                <br />
                <a href="https://leadingaccess.lhw.com/main/sell/contact" target="blank">CONTACT AN LHW SALES REPRESENTATIVE</a>
              </p>
            </div>
          </div>

          <div className="imageOnCopy">
            <img src="https://front.travpromobile.com/678/Kulm_Hotel_Exterior_Winter_2020 (1).jpeg" className="splitter" alt="" />
            <div className="copy">
              <h2>LEADERS CLUB ENROLLMENT</h2>
              <p>
                Enroll your clients in Leaders Club now by contacting your LHW sales representative or a{' '}
                LHW Worldwide Reservation and Service Center and provide the following client information:
                <ul>
                  <li>Preferred salutation</li>
                  <li>First and last name</li>
                  <li>Email address</li>
                  <li>Physical address (street, city, country)</li>
                  <li>Preferred language </li>
                </ul>
              </p>
              <a href="https://leadingaccess.lhw.com/main/sell/contact" target="blank" className="button">Contact Us &gt;</a>
            </div>
          </div>

          <div className="imageOnCopy doubleHeight">
            <img src="https://front.travpromobile.com/678/palace_dez2013_002_(1).jpeg" className="splitter" alt="" />
            <div className="copy right">
              <h2>HOW TO BOOK A LEADERS CLUB MEMBER RESERVATION</h2>
              <p>
              To ensure you receive your commission and your clients earn points, be sure to include your client’s Leaders Club member number when you book:
              <br /><br />
              <hr />
              <br />
              Through the GDS: You will append your client’s Leaders Club member number to the end of the sell. In the examples below, the member’s number is 123456789:
              <br /><br />
              <u>AMADEUS / FT</u><br />
              EXAMPLE: HS1/BS-12345675/ GCVI1234123412341234EXP1218 / <mark>FT-123456789</mark>
              <br /><br />
              <u>APOLLO/GALILEO / FG</u><br />
              EXAMPLE: 01INSIDE1/G-VI1234123412341234EXP1217 / <mark>FG-123456789</mark>
              <br /><br />
              <u>SABRE / ID</u><br />
              EXAMPLE: 0H1¥1/GVI1234123412341234EXP 01 02-NAME / <mark>ID-123456789</mark>
              <br /><br />
              <u>WORLDSPAN / FG</u><br />
              EXAMPLE: H01/G-CCVI1234123412341234EXP12-18 / <mark>FG-123456789</mark>
              <br /><br />
              <hr />
              <br />
              By calling the LHW Worldwide Reservations and Service Center and using your IATA/agency ID.
              <br />
              <br />
              <u>LHW Worldwide Reservations and Service Centers</u>
              <br />
              United States, Canada, Puerto Rico, and U.S. Virgin Islands<br />
              VOICE RESERVATIONS: (1-800) 223-6800 TOLL FREE
              <br /><br />
              Austria, Belgium, France, Germany, Ireland, Spain, Switzerland, The Netherlands, and UK<br />
              VOICE RESERVATIONS:  00-800-2888-8882
              <br /><br />
              <a href="https://www.lhw.com/customer-care" target="_blank">VIEW ALL COUNTRIES ></a>
              <br /><br />
              <hr />
              <br />
              On the <a href="https://cbt.synxis.com/?chainId=24447" target="_blank">VITA website</a> (please call LHW Worldwide Reservations afterward to add your client’s Leaders Club member number to the reservation)
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
